module.exports = __webpack_public_path__ + "img/vertical-inactive.2e948f0f.svg";